import React from 'react'
import { useIntl } from 'react-intl'

import { useTCF } from 'components/TCFProvider'

import LazyStandardConsentPrompt from './LazyStandardConsentPrompt'
import LazyTCFConsentPrompt from './LazyTCFConsentPrompt'

import Locale from './locale'


export default function ConsentPrompt() {
  const { gvl } = useTCF()
  const { formatMessage } = useIntl()

  // The vendor list picks between two whole prompts rather than between two
  // messages inside one prompt, so no message has to load separately after the
  // prompt has already opened.
  const Component = ( gvl ) ? LazyTCFConsentPrompt : LazyStandardConsentPrompt

  return (
    <Component
      ariaLabel={ formatMessage(Locale.ariaLabel) }
    />
  )
}
